import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import defaultimg from "../assets/images/default.png";
import {
  makeStyles,
  Grid,
  Typography,
  Button,
  CircularProgress,
} from "@material-ui/core";
import { hexToCSSFilter } from "hex-to-css-filter";
import { useNavigate, useLocation } from "react-router-dom";
import CyntraLogo from "../assets/images/cyntra_logo.svg";
import {
  BUTTON_COLOR,
  TEXT_COLOR,
  IMG_URL,
  VIDEO_BASE_URL,
} from "../utils/constant";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { set_order_type } from "../store/actions/action";
import SignInPopup from "./login/SignInPopup";
import deliveryIcon from "../assets/images/DEL.svg";
import takeAway from "../assets/images/TA.svg";
import dineIn from "../assets/images/DI.svg";
import deliveryWebIcon from "../assets/web/delivery.svg";
import thirtyMinWebIcon from "../assets/web/thirty-min.svg";
import freshWebIcon from "../assets/web/fresh.svg";
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Navbar from '../components/Navbar';
import WebFooter from '../components/WebFooter';
import { useActiveStoreCatalog } from '../store/selectors/menu';
import { preload_menu_data } from '../store/actions/action';

// Helper: on desktop (>=768px) pin fixed elements to the 814px centered frame
const FRAME_WIDTH = 814;
const getFrameFixed = () => {
  if (window.innerWidth >= 768) {
    const offset = `calc(50% - ${FRAME_WIDTH / 2}px)`;
    return { left: offset, right: offset, width: `${FRAME_WIDTH}px` };
  }
  return { left: 0, right: 0, width: "100%" };
};

function Home() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const frameFixed = getFrameFixed();
  const [isReload, setIsReload] = useState(true);
  const [openUserInfo, setOpenUserInfo] = useState(false);
  const [guest, setGuest] = useState(false);
  const [goToCart, setGoToCart] = useState(false);

  const isDesktop = useMediaQuery('(min-width: 900px)');
  const { categories: catalogCategories } = useActiveStoreCatalog();
  const customer = useSelector(state => state.customerReducer?.customer);

  useEffect(() => {
    if (isDesktop && (!catalogCategories || catalogCategories.length === 0)) {
      dispatch(preload_menu_data());
    }
  }, [isDesktop, catalogCategories, dispatch]);

  const sessionReducer = useSelector(state => state.sessionReducer);
  const storeInfo = useSelector(state => state.sessionReducer.store_details);
  const storeInfoConfig = useSelector(state => state.sessionReducer.store_config);
  const is_fsr = useSelector(state => state.sessionReducer.is_fsr);
  const tent_id = useSelector(state => state.sessionReducer.tent_id);
  const orderTypes = useSelector(state => state.sessionReducer.order_types);
  const associatedStores = useSelector(state => state.sessionReducer.associated_stores);
  const catinfo = useSelector(state => state.catalogReducer.categories);

  useEffect(() => {
    localStorage.removeItem("TENT");
    if (sessionReducer?.tent_id) {
      dispatch({
        type: 'WEB_LOGIN',
        payload: {
          ...sessionReducer,
          tent_id: null
        }
      });
    }
  }, [dispatch, sessionReducer?.tent_id]);

  const getOrderTypeIcon = (order_code) => {
    switch (order_code?.toLowerCase()) {
      case "del":
        return deliveryIcon;
      case "ta":
        return takeAway;
      case "di":
        return dineIn;
      default:
        return null;
    }
  };
  let primaryColor = storeInfoConfig?.general_config?.primary_color;
  let secondaryColor = storeInfoConfig?.general_config?.secondary_color;

  const useStyles = makeStyles(() => ({
    main_sectiondiv1: {
      background: "#0000",
      height: "40vh",
      position: "relative",
      padding: "0px",
    },

    // main_sectiondiv3: {
    //   height: "55vh",
    //   margin: "0",
    //   zIndex: 2,
    //   padding: "0rem 2rem",
    //   clipPath: "polygon(0 20%, 100% 0, 100% 100%, 0% 100%)",
    //   backgroundColor: "white",
    //   // paddingTop: "20px",
    //   display: "flex",
    //   justifyContent: "center",
    //   // alignItems:"center",
    // },
    main_button: {
      width: "90%",
      padding: "1rem",
      borderRadius: "8px",
      fontSize: "1.2rem",
      textTransform: "capitalize",
    },
    main_bottom: {
      fontSize: "1.2rem",
      textTransform: "capitalize",
      display: "flex",
      flexDirection: "column",
      padding: "0rem 0rem 1rem 0rem",
      alignContent: "center",
      alignItems: "center",
    },
    text_bottom: {
      textTransform: "capitalize",
      color: primaryColor || "black",
      padding: "0.5rem",
      fontSize: "1rem",
      fontWeight: "800",
      position: "fixed",
      ...frameFixed,
      bottom: 25,
      zIndex: 10,
    },
    img_bottom: {
      position: "absolute",
      textTransform: "capitalize",
      color: primaryColor || "black",
      padding: "0.5rem",
      fontSize: "1rem",
      left: 0,
      right: 0,
      bottom: "0%",
      zIndex: 10,
    },
    border: {
      backgroundColor: "#99ff3b",
      bottom: "-2px",
      clipPath: "polygon(-5% 100%,100% -2%,100% 100%,0 100%)",
      height: "18vh",
      position: "absolute",
      width: "101vw",
    },
    videoBackground: {
      position: "fixed",
      top: 0,
      ...frameFixed,
      height: "100%",
      zIndex: -1,
      objectFit: "cover",
    },
    videoOverlay: {
      position: "fixed",
      top: 0,
      ...frameFixed,
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.4)",
      zIndex: -1,
    },

    contentWithBackground: {
      height: "65vh",
      // backgroundColor: primaryColor || "white",
      // position: "fixed",
      // left: 0,
      // right: 0,
      // bottom: 0,
      // zIndex: 10,
      // clipPath: "polygon(0 20%, 100% 0, 100% 100%, 0% 100%)",

      // // clipPath: "polygon(34% 13%, 54% 11%, 100% 2%, 100% 100%, 68% 100%, 32% 100%, 0 100%, 0 11%, 13% 14%)",

      // borderTopLeftRadius: 0,
      // borderTopRightRadius: 0,
    },
    main_sectiondiv3: {
      height: "auto",
      minHeight: "auto",
      margin: "0",
      padding: "0rem 1.5rem 2rem",
      display: "flex",
      justifyContent: "center",
      backgroundColor: "#ffffff",
      position: "relative",
      ...frameFixed,
      zIndex: 10,
      overflow: "visible",
    },
  }));
  const classes = useStyles();

  useEffect(() => {
    setIsReload(false);
  }, []);

  // Once order types arrive from login, handle auto-navigation if needed
  useEffect(() => {
    if (!orderTypes?.length) return;
    // Explicit Home/Logout navigation asks to land on "/" itself —
    // don't immediately bounce back out via the post-login auto-skip below.
    if (location.state?.skipAutoRedirect) return;
    if (sessionStorage.getItem("HAS_REDIRECTED_FROM_HOME")) return;

    // FSR scan: order type is auto-set in WebLogin thunk. Route to /stores only
    // if there are sibling stores to pick from; otherwise go straight to /menu.
    if (is_fsr || tent_id) {
      const web_ordering_setting = storeInfoConfig?.web_ordering_setting || {};
      const hasAssociated = Array.isArray(associatedStores) && associatedStores.length > 0;
      if (!web_ordering_setting?.is_menu) {
        sessionStorage.setItem("HAS_REDIRECTED_FROM_HOME", "true");
        navigate(hasAssociated ? "/stores" : "/menu");
        return;
      }
    }
  }, [orderTypes, is_fsr, tent_id, storeInfoConfig, associatedStores, navigate, location.state]);

  let Type = orderTypes?.filter((data) => data?.status === true);
  if (is_fsr) {
    Type = Type?.filter((data) => data?.order_code?.toLowerCase() === "di");
  }
  let menuStore = storeInfoConfig?.web_ordering_setting?.is_menu;
  let customerAsGuest =
    storeInfoConfig?.web_ordering_setting?.qr_customer_as_guest;

  const web_ordering_setting = storeInfoConfig?.web_ordering_setting || {};
  const hasAssociated = Array.isArray(associatedStores) && associatedStores.length > 0;
  const isMultiOutlet = (web_ordering_setting?.is_multi_store_qr === true
    || (web_ordering_setting?.associated_store_qr || []).length > 0)
    && hasAssociated;

  // brightness(0) zeroes out the hardcoded SVG fill color (blue) → then the
  // generated filter tints the icon to the store's primaryColor.
  const rawFilter = hexToCSSFilter(primaryColor || "#000000").filter;
  const filterStyle = primaryColor ? `brightness(0) ${rawFilter}` : "none";

  return (
    <>
      <style>
        {`
          ::-webkit-scrollbar {
            display: none;
          }
          body {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
        `}
      </style>
      {isDesktop ? (
        <Box sx={{ width: '100%', minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#f8f9fa', overflowX: 'hidden', margin: 0, padding: 0 }}>
          <Navbar />

          {/* Hero Banner */}
          <Box sx={{ px: { xs: '16px', md: '35px' }, py: '20px', width: '100%', boxSizing: 'border-box' }}>
            <Box
              sx={{
                width: '100%',
                mx: 'auto',
                minHeight: '420px',
                height: { md: '500px' },
                borderRadius: '12px',
                overflow: 'hidden',
                isolation: 'isolate',
                background: 'linear-gradient(135deg, #1A1A1A 0%, #2D2D2D 100%)',
                boxShadow: '0px 8px 10px -6px #0000001A, 0px 20px 25px -5px #0000001A',
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                position: 'relative',
              }}
            >
              {/* Left Content Area */}
              <Box
                sx={{
                  flex: { xs: '1', md: '0 0 35%' },
                  p: { xs: 3, md: 5 },
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  textAlign: 'left',
                  background: 'linear-gradient(135deg, #1A1A1A 0%, #2D2D2D 100%)',
                  zIndex: 2,
                  position: 'relative',
                  boxSizing: 'border-box',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    textAlign: 'left',
                    width: '100%',
                  }}
                >
                  <Typography
                    style={{
                      color: '#A0A0A0',
                      fontSize: '12px',
                      fontWeight: 700,
                      lineHeight: 1.2,
                      letterSpacing: '1.5px',
                      textTransform: 'uppercase',
                      marginBottom: '16px',
                      fontFamily: 'Satoshi, sans-serif',
                      textAlign: 'left',
                    }}
                  >
                    EXCLUSIVE OFFER
                  </Typography>
                  <Typography
                    style={{
                      color: 'white',
                      fontWeight: 800,
                      fontSize: isDesktop ? '2.4rem' : '2rem',
                      lineHeight: 1.15,
                      letterSpacing: '-0.5px',
                      marginBottom: '16px',
                      fontFamily: 'Satoshi, sans-serif',
                      textAlign: 'left',
                    }}
                  >
                    Take 50% Off Your<br />First Feast
                  </Typography>
                  <Typography
                    style={{
                      color: '#B0B0B0',
                      fontSize: '15px',
                      fontWeight: 400,
                      lineHeight: 1.4,
                      marginBottom: '32px',
                      fontFamily: 'Satoshi, sans-serif',
                      textAlign: 'left',
                    }}
                  >
                    Delivered in 20m · Free delivery over ₹999
                  </Typography>
                  <Button
                    variant="contained"
                    endIcon={<ArrowRightAltIcon />}
                    style={{
                      backgroundColor: primaryColor || '#FF3B00',
                      color: 'white',
                      padding: '14px 36px',
                      fontSize: '16px',
                      fontWeight: 700,
                      lineHeight: 1.2,
                      textTransform: 'none',
                      borderRadius: '4px',
                      fontFamily: 'Satoshi, sans-serif',
                      boxShadow: 'none',
                      alignSelf: 'flex-start',
                    }}
                    onClick={() => {
                      const dineInOrder = orderTypes?.find(
                        (data) => data?.status === true && data?.order_code?.toUpperCase() === "DI"
                      );
                      dispatch(set_order_type({ order: dineInOrder || { order_code: 'DI' } }));
                      navigate(isMultiOutlet ? "/stores" : "/menu");
                    }}
                  >
                    Order Now
                  </Button>
                </Box>
                <Typography
                  style={{
                    color: '#CCCCCC',
                    fontSize: '13px',
                    fontWeight: 400,
                    lineHeight: 1.2,
                    fontFamily: 'Satoshi, sans-serif',
                    textAlign: 'left',
                    position: 'absolute',
                    bottom: isDesktop ? '40px' : '24px',
                    left: isDesktop ? '40px' : '24px',
                  }}
                >
                  *T&C apply
                </Typography>
              </Box>

              {/* Right Video Container */}
              <Box
                sx={{
                  flex: { xs: '1', md: '0 0 65%' },
                  position: 'relative',
                  minHeight: { xs: '240px', md: '100%' },
                  overflow: 'hidden',
                  borderRadius: { xs: '0 0 12px 12px', md: '0 12px 12px 0' },
                }}
              >
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    display: 'block',
                    borderRadius: 'inherit',
                  }}
                >
                  <source
                    src={`${VIDEO_BASE_URL}/${storeInfo?.parent_store_id}/${storeInfo?.store_video?.[0]?.video_link}`}
                    type="video/mp4"
                  />
                </video>

                {/* Soft left gradient overlay to blend into left dark card */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '25%',
                    height: '100%',
                    background: 'linear-gradient(to right, #1A1A1A, transparent)',
                    display: { xs: 'none', md: 'block' },
                    zIndex: 1,
                  }}
                />

                {/* 50% OFF Badge (Rotated 12 degrees) */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: 24,
                    right: 24,
                    zIndex: 3,
                    width: 64,
                    height: 64,
                    borderRadius: '50%',
                    backgroundColor: primaryColor || '#FF3B00',
                    color: 'white',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0px 4px 12px rgba(0,0,0,0.3)',
                    fontWeight: 900,
                    fontSize: '13px',
                    lineHeight: 1.1,
                    textAlign: 'center',
                    transform: 'rotate(-21deg)',
                  }}
                >
                  <span>50%</span>
                  <span>OFF</span>
                </Box>
              </Box>
            </Box>

            {/* Pagination Dots */}
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, mt: 1.5 }}>
              <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: '#D0D0D0' }} />
              <Box sx={{ width: 20, height: 6, borderRadius: '3px', backgroundColor: primaryColor || '#FF3B00' }} />
              <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: '#D0D0D0' }} />
              <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: '#D0D0D0' }} />
            </Box>
          </Box>

          {/* Order Types */}
          <Box sx={{ pt: 6, pb: 4, px: { md: 4, lg: 8 } }}>
            <div
              style={{
                fontWeight: 800,
                fontSize: '2rem',
                lineHeight: 1.2,
                textAlign: 'center',
                color: '#111827',
                marginBottom: '8px',
                fontFamily: 'Satoshi, sans-serif',
              }}
            >
              How would you like your order?
            </div>
            <div
              style={{
                fontWeight: 500,
                fontSize: '1rem',
                textAlign: 'center',
                color: '#6B7280',
                marginBottom: '36px',
                fontFamily: 'Satoshi, sans-serif',
              }}
            >
              Choose your preferred dining experience
            </div>

            <Grid container spacing={3} justifyContent="center" sx={{ maxWidth: '1200px', margin: '0 auto' }}>
              {Type?.map((value) => {
                const gridSpan = Type.length === 2 ? 6 : Type.length === 1 ? 12 : 4;
                let subtitle = `Select this option for ${value?.order_type?.toLowerCase()} service.`;
                const code = value?.order_code?.toLowerCase();
                if (code === 'di') subtitle = "Enjoy a premium dining experience at our restaurant with full table service.";
                if (code === 'ta') subtitle = "Order ahead, skip the wait. Pick up your fresh meal from our counter.";
                if (code === 'del') subtitle = "Hot meals delivered to your doorstep in 30 minutes or less.";

                return (
                  <Grid item xs={12} sm={6} md={gridSpan} key={value?._id}>
                    <Card
                      style={{
                        padding: '28px 24px',
                        textAlign: 'left',
                        cursor: 'pointer',
                        borderRadius: '7px',
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: '#E5E7EB',
                        boxShadow: 'none',
                        transition: 'box-shadow 0.2s, transform 0.2s',
                        height: '100%',
                        boxSizing: 'border-box'
                      }}
                      onMouseOver={(e) => { e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.06)'; e.currentTarget.style.transform = 'translateY(-3px)'; }}
                      onMouseOut={(e) => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'translateY(0)'; }}
                      onClick={() => {
                        dispatch(set_order_type({ order: value }));
                        navigate(isMultiOutlet ? "/stores" : "/menu");
                      }}
                    >
                      <Box
                        sx={{
                          backgroundColor: primaryColor ? `${primaryColor}15` : '#FFF1EC',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '68px',
                          height: '68px',
                          borderRadius: '4px',
                          marginBottom: '20px'
                        }}
                      >
                        <img src={getOrderTypeIcon(value?.order_code)} alt="" style={{ height: '46px', width: '46px', objectFit: 'contain', filter: filterStyle }} />
                      </Box>
                      <div
                        style={{
                          fontWeight: 800,
                          color: primaryColor || '#EB5C24',
                          fontSize: '1.45rem',
                          marginBottom: '8px',
                          fontFamily: 'Satoshi, sans-serif'
                        }}
                      >
                        {value?.order_type}
                      </div>
                      <div
                        style={{
                          color: '#6B7280',
                          fontSize: '1.2rem',
                          lineHeight: 1.5,
                          fontWeight: 400,
                          fontFamily: 'Satoshi, sans-serif'
                        }}
                      >
                        {subtitle}
                      </div>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </Box>

          {/* Categories Grid */}
          <Box sx={{ pt: 4, pb: 8, px: { md: 4, lg: 8 } }}>
            <Typography align="center" style={{ fontWeight: 'bold', fontSize: '2rem', marginBottom: '8px', fontFamily: 'Satoshi, sans-serif', color: '#111827' }}>Browse Categories</Typography>
            <Typography align="center" style={{ marginBottom: '40px', color: '#6B7280', fontFamily: 'Satoshi, sans-serif', fontSize: '1rem', fontWeight: 500 }}>What are you craving today?</Typography>

            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: {
                  xs: 'repeat(2, 1fr)',
                  sm: 'repeat(3, 1fr)',
                  md: 'repeat(5, 1fr)',
                },
                gap: '24px',
                maxWidth: '1720px',
                mx: 'auto',
                justifyItems: 'center',
              }}
            >
              {((catinfo && catinfo.length > 0) ? catinfo : catalogCategories)?.map((cat, index) => {
                const sid = String(cat?.store_id || storeInfo?.store_id || '').trim();
                const rawImg = cat?.cat_img ? String(cat.cat_img).trim().replace(/^\/+/, '') : '';
                const baseUrl = (IMG_URL || '').replace(/\/+$/, '');
                const catImgSrc = !rawImg
                  ? defaultimg
                  : (rawImg.startsWith('http://') || rawImg.startsWith('https://'))
                  ? rawImg
                  : (sid && !rawImg.startsWith(`${sid}/`))
                  ? `${baseUrl}/${sid}/${rawImg}`
                  : `${baseUrl}/${rawImg}`;
                const catName = cat?.cat_name || cat?.category_name || cat?.name || "Category";

                return (
                  <Box
                    key={cat?.category_id || cat?.cat_id || index}
                    sx={{
                      position: 'relative',
                      width: '100%',
                      aspectRatio: '1 / 1',
                      borderRadius: '12px',
                      overflow: 'hidden',
                      cursor: 'pointer',
                      opacity: 1,
                      boxShadow: '0px 10px 32px -4px #140A052E, 0px 2px 6px 0px #00000012',
                      borderBottom: `4px solid ${primaryColor || '#EB5C24'}`,
                      transition: 'transform 0.25s ease, box-shadow 0.25s ease',
                      '&:hover': {
                        transform: 'translateY(-4px)',
                      },
                    }}
                    onClick={() => {
                      const dineInOrder = orderTypes?.find(
                        (data) => data?.status === true && data?.order_code?.toUpperCase() === "DI"
                      );
                      dispatch(set_order_type({ order: dineInOrder || { order_code: 'DI' } }));
                      navigate(isMultiOutlet ? "/stores" : "/menu", { state: { selectedCategory: cat?.category_id || cat?.cat_id } });
                    }}
                  >
                    <img
                      src={catImgSrc}
                      alt={catName}
                      onError={(e) => { e.target.onerror = null; e.target.src = defaultimg; }}
                      style={{ width: '100%', height: '100%', maxWidth: '100%', objectFit: 'cover' }}
                    />
                    <Box
                      sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        height: '30%',
                        background: '#00000099',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '8px 12px',
                        boxSizing: 'border-box',
                      }}
                    >
                      <div
                        style={{
                          fontWeight: 800,
                          textAlign: 'center',
                          fontSize: '23px',
                          color: 'white',
                          fontFamily: 'Satoshi, sans-serif',
                          lineHeight: 1.1,
                        }}
                      >
                        {catName}
                      </div>
                    </Box>
                  </Box>
                );
              })}
            </Box>
          </Box>

          {/* Features */}
          <Box
            sx={{
              py: { xs: 5, md: 7 },
              px: '34px',
              backgroundColor: '#FAFAFA',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'stretch',
              gap: '12px',
              flexWrap: { xs: 'wrap', md: 'nowrap' },
              maxWidth: '100%',
            }}
          >
            {[
              {
                icon: deliveryWebIcon,
                title: 'Free Delivery',
                subtitle: 'On orders above ₹499',
              },
              {
                icon: thirtyMinWebIcon,
                title: '30 Minutes Delivery',
                subtitle: "Or we'll give you 10% off",
              },
              {
                icon: freshWebIcon,
                title: 'Fresh & Hygienic',
                subtitle: 'FSSAI certified kitchen',
              },
            ].map((item, index) => (
              <Box
                key={index}
                sx={{
                  flex: { xs: '1 1 100%', md: '1 1 auto' },
                  width: '100%',
                  backgroundColor: '#FFFFFF',
                  borderRadius: '8px',
                  borderWidth: '1px',
                  borderStyle: 'solid',
                  borderColor: '#EBEBEB',
                  p: '24px 20px',
                  minHeight: '97px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '18px',
                  boxSizing: 'border-box',
                }}
              >
                {/* SVG Small Card Container */}
                <Box
                  sx={{
                    width: '73px',
                    height: '73px',
                    borderRadius: '8px',
                    backgroundColor: primaryColor ? `${primaryColor}15` : '#FFF2EC',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  <img
                    src={item.icon}
                    alt={item.title}
                    style={{
                      width: '46px',
                      height: '46px',
                      objectFit: 'contain',
                      filter: filterStyle,
                    }}
                  />
                </Box>

                {/* Text Block */}
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left' }}>
                  <Typography
                    style={{
                      fontWeight: 700,
                      fontSize: '20px',
                      color: '#1A1A1A',
                      fontFamily: 'Satoshi, sans-serif',
                      lineHeight: 1.25,
                      marginBottom: '4px',
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    style={{
                      fontWeight: 400,
                      fontSize: '16.5px',
                      color: '#71717A',
                      fontFamily: 'Satoshi, sans-serif',
                      lineHeight: 1.3,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {item.subtitle}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>

          <WebFooter storeInfo={storeInfo} primaryColor={primaryColor} />

          <SignInPopup
            openUserInfo={openUserInfo}
            setOpenUserInfo={setOpenUserInfo}
            storeInfo={storeInfo}
            storeInfoConfig={storeInfoConfig}
            guest={guest}
            goToCart={goToCart}
          />
        </Box>
      ) : !isReload ? (
        <Grid container justifyContent="center">
          <video
            className={classes.videoBackground}
            autoPlay
            muted
            loop
            playsInline
          >
            <source
              src={`${VIDEO_BASE_URL}/${storeInfo?.parent_store_id}/${storeInfo?.store_video && storeInfo?.store_video[0]?.video_link
                }`}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>

          {menuStore ? (
            <>
              <Grid
                style={{
                  minHeight: "100vh",
                  position: "relative",
                  zIndex: 1,
                  background: primaryColor,
                }}
              >
                <Grid
                  style={{ height: "60vh", position: "relative", zIndex: 1 }}
                >
                  <img
                    className="homebgimg"
                    style={{
                      minHeight: "100%",
                      minWidth: "100%",
                      maxHeight: "100%",
                      maxWidth: "100%",
                      borderBottomRightRadius: "31px",
                      borderBottomLeftRadius: "31px",
                      opacity: 0.9,
                    }}
                    src={
                      storeInfo.bg_img
                        ? `${IMG_URL}${storeInfo.store_id}/${storeInfo.bg_img}`
                        : ""
                    }
                  />
                </Grid>

                <Grid
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{
                    left: "0px",
                    right: "0px",
                    display: "flex",
                    bottom: "0%",
                    justifyContent: "center",
                    padding: "0rem 1.8rem",
                    margin: "0px",
                    height: "30vh",
                    flexDirection: "row",
                    alignContent: "center",
                    alignItems: "center",
                    flexWrap: "wrap",
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  <img
                    alt="Logo"
                    style={{
                      marginBottom: "5%",
                      ...(storeInfo.store_id === "368" || "366"
                        ? { width: "40%" }
                        : { minWidth: "90%" }),
                    }}
                    src={storeInfo.store_display_logo}
                  />

                  <Button
                    fullWidth
                    variant="contained"
                    style={{
                      fontSize: "1.1rem",
                      fontFamily: "Lucida Bright",
                      maxWidth: "210px",
                      margin: "0.5rem",
                      color: "white",
                      background: "#965B22",
                    }}
                    onClick={() => {
                      dispatch(set_order_type({ order: "menu" }));
                      navigate(isMultiOutlet ? "/stores" : (isDesktop ? "/menu" : "/menu-items"));
                      setGuest(true);
                      setGoToCart(true);
                    }}
                    className={classes.main_button}
                  >
                    Get Started
                    <NavigateNextIcon
                      style={{
                        position: "absolute",
                        right: "8px",
                        fontSize: "2rem",
                      }}
                    />
                  </Button>
                </Grid>

                <SignInPopup
                  openUserInfo={openUserInfo}
                  setOpenUserInfo={setOpenUserInfo}
                  storeInfo={storeInfo}
                  storeInfoConfig={storeInfoConfig}
                  guest={guest}
                  goToCart={goToCart}
                />
              </Grid>
            </>
          ) : (
            <>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                className={classes.main_sectiondiv1}
              >
                {/* <Offline
                  style={{ position: "absolute", width: "92%", zIndex: 10 }}
                >
                  <Alert severity="error">
                    You are Offline, Check your internet connection!!
                  </Alert>
                </Offline> */}
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                className={classes.main_sectiondiv3}
                style={{ minHeight: "auto", height: "auto", paddingBottom: "calc(20px + env(safe-area-inset-bottom, 0px))" }}
              >
                {/* Wave curve transition between video and white panel */}
                <svg
                  style={{
                    position: "absolute",
                    top: "-49px",
                    left: 0,
                    width: "100%",
                    height: "50px",
                    display: "block",
                    pointerEvents: "none",
                  }}
                  viewBox="0 0 390 60"
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 40 C60 55 120 52 180 38 C235 25 285 8 340 18 C365 22 380 28 390 32 L390 60 L0 60 Z"
                    fill="#fff"
                  />
                </svg>
                <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", height: "100%", position: "relative" }}>
                  {!isReload && (
                    <>
                      {/* Logo and Store Name */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          marginTop: "0.5rem",
                          width: "100%",
                        }}
                      >
                        <img
                          alt="Logo"
                          style={{
                            maxWidth: "180px",
                            maxHeight: "20vh", // Makes logo responsive on very short screens
                            width: "auto",
                            marginBottom: "8px",
                            marginTop: "8px",
                          }}
                          src={storeInfo.store_display_logo}
                        />
                      </div>

                      {/* Let's Get Started & Subtitle */}
                      <Grid
                        container
                        direction="column"
                        alignItems="center"
                        style={{ gap: "2px" }}
                      >
                        <Typography align="center">
                          <span
                            style={{
                              fontFamily: "Satoshi, sans-serif",
                              fontSize: "24px",
                              fontStyle: "italic",
                              color: primaryColor,
                              fontWeight: "600",
                              textAlign: "center",
                              display: "block",
                              marginBottom: "0.5rem",
                            }}
                          >
                            Let's Get Started!
                          </span>
                        </Typography>
                        <Typography align="center">
                          <span
                            style={{
                              fontFamily: "Satoshi, sans-serif",
                              fontSize: "14px",
                              color: primaryColor,
                              fontWeight: "500",
                              textAlign: "center",
                              display: "block",
                              marginBottom: "0.5rem",
                            }}
                          >
                            {storeInfo?.store_industry == "Warehouse"
                              ? "How would you like to shop today?"
                              : "How would you like to enjoy your meal today?"}
                          </span>
                        </Typography>
                      </Grid>

                      {/* Buttons Grid */}
                      <Grid item xs={12} sm={12} md={12} lg={12} style={{ width: "100%", paddingBottom: "20px", flexGrow: 1 }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            flexWrap: "wrap",
                            gap: "0.5rem",
                            marginTop: "0.2rem",
                            width: "100%",
                          }}
                        >
                          {Type?.map((value, index) => (
                            <Button
                              key={value?._id || index}
                              variant="contained"
                              style={{
                                flex: Type?.length === 1 ? "0 0 85%" : "0 0 calc(46% - 0.25rem)",
                                minWidth: 0,
                                maxWidth: "140px",
                                borderRadius: "9px",
                                border: "0.5px solid #DDDDDD",
                                height: "calc((60vh - 200px) / 2)",
                                maxHeight: "100px",
                                minHeight: "55px", // Allow buttons to shrink much more
                                color: primaryColor || TEXT_COLOR,
                                background: "#FFFFFF",
                                padding: "2px 4px",
                                boxShadow: "0px 0px 15px 0px #00000015",
                                textTransform: "none",
                              }}
                              onClick={() => {
                                navigate(isMultiOutlet ? "/stores" : "/menu");
                                dispatch(set_order_type({ order: value }));
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "100%",
                                  gap: "2px", // reduced gap
                                }}
                              >
                                {getOrderTypeIcon(value?.order_code) && (
                                  <img
                                    src={getOrderTypeIcon(value?.order_code)}
                                    alt={`${value?.order_code} icon`}
                                    style={{
                                      width: "100%",
                                      height: "36px", // smaller icon
                                      objectFit: "contain",
                                      filter: filterStyle,
                                    }}
                                  />
                                )}
                                <div
                                  style={{
                                    width: "100%",
                                    borderBottom: "0.5px solid #DDDDDD",
                                    margin: "2px 0",
                                  }}
                                />
                                <span
                                  style={{
                                    fontSize: "0.8rem", // smaller text
                                    fontWeight: "600",
                                    textAlign: "center",
                                    textTransform: "capitalize",
                                    color: "#333",
                                    lineHeight: 1.1,
                                  }}
                                >
                                  {value?.order_type?.toLowerCase()}
                                </span>
                              </div>
                            </Button>
                          ))}
                        </div>
                      </Grid>

                      {/* Footer Logo */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          position: "relative",
                          marginTop: "24px",
                          paddingBottom: "calc(16px + env(safe-area-inset-bottom, 0px))",
                          paddingTop: "10px",
                          width: "100%",
                          zIndex: 1,
                        }}
                      >
                        <span style={{ fontSize: "0.85rem", color: "#666666" }}>Powered by</span>
                        <img alt="Logo" style={{ width: "65px", marginTop: "2px" }} src={CyntraLogo} />
                      </div>
                    </>
                  )}
                </div>
              </Grid>
            </>
          )}
        </Grid>
      ) : (
        <Grid
          className="loadingreport"
          style={{ paddingTop: "20rem", position: "relative", zIndex: 1 }}
        >
          <CircularProgress variant="indeterminate" />
          <p
            style={{
              color: "white",
              textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
            }}
          >
            Loading{" "}
          </p>
        </Grid>
      )}
    </>
  );
}

export default Home;
